import React from 'react';
import IModel from '../../../../models/model';

import InputTextField from '../../../inputfields/InputTextField';

interface IProductField<T extends IModel> {
  readOnly?: boolean;
  state: T;
  setState: (state: T) => void;
  label?: string;
  field: keyof T;
  required?: boolean;
  hideComponentLabel?: boolean;
}

export const GenericField = <T extends IModel>({
  readOnly,
  state,
  setState,
  label,
  field,
  required = true,
  hideComponentLabel = false,
}: IProductField<T>) => {
  // TODO any
  const handleChange = ({ target }: any) => setState({ ...state, [target.name]: target.value });

  return (
    <InputTextField
      readOnly={readOnly}
      label={label}
      dense={false}
      inputName={field}
      required={required}
      value={state[field]}
      onChange={handleChange}
      withLabel
      hideComponentLabel={hideComponentLabel}
      labelOptions={{
        heading: label,
      }}
    />
  );
};

export default GenericField;
